import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analisis-estrategico/estrategia-ganar-clientes/EstrategiaGanarClientesClient.tsx");
